import { get, download } from '@/services/http';

/**
 * Data structure for flow template
 */
export interface FlowTemplateData {
  id?: string;
  name?: string;
  description?: string;
  category?: string;
  triggerType?: string;
  tags?: string[];
}

export class FlowTemplateModel {
  public id: string;
  public name: string;
  public description: string;
  public category: string;
  public triggerType: string;
  public tags: string[];

  constructor(data: FlowTemplateData = {}) {
    this.id = data.id || '';
    this.name = data.name || '';
    this.description = data.description || '';
    this.category = data.category || '';
    this.triggerType = data.triggerType || '';
    this.tags = data.tags || [];
  }

  public mapData(data: FlowTemplateData = {}): void {
    this.id = data.id ?? this.id;
    this.name = data.name ?? this.name;
    this.description = data.description ?? this.description;
    this.category = data.category ?? this.category;
    this.triggerType = data.triggerType ?? this.triggerType;
    this.tags = data.tags ?? this.tags;
  }

  public async fetch(): Promise<void> {
    if (!this.id) {
      throw new Error('Cannot fetch template: id is required');
    }

    const res = await get<{ template: FlowTemplateData }>(`/flow/templates/${this.id}`);

    if (res.template) {
      this.mapData(res.template);
    }
  }

  public async download(fileName?: string): Promise<void> {
    if (!this.id) {
      throw new Error('Cannot download template: id is required');
    }

    const blob = await download(`/flow/templates/${this.id}/download`);

    // Create download link
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = fileName || `assisty-${this.id}.flow`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
  }

  public static async fetchAll(): Promise<FlowTemplateModel[]> {
    const res = await get<{ templates: FlowTemplateData[] }>('/flow/templates');
    return (res.templates || []).map((data) => new FlowTemplateModel(data));
  }
}
